
  
// Script Généré le : 03/03/2026 16:22:21 via ModelGenerator.nt
//  IntUser.ts
// Chemin de sortie : ..\..\..\front-shared\paf-shared\projects\ngx-paf-common\src\lib\Models\IntUser.ts

import {IntUserStatutHistory } from "./IntUserStatutHistory";
import {Profil } from "./Profil";
import {Family } from "./Family";
import {Contact } from "./Contact";
import {IntUserPerimeters_XRP } from "./IntUserPerimeters_XRP";
export class IntUser {

  // int Id
  public Id: number=0;

  // string UtiGid
  public UtiGid?: string=null;

  // string UtiCiv
  public UtiCiv?: string=null;

  // string UtiPrenom
  public UtiPrenom?: string=null;

  // string UtiNom
  public UtiNom?: string=null;

  // string UtiMail
  public UtiMail?: string=null;

  // string UtiTel
  public UtiTel?: string=null;

  // string Observations
  public Observations?: string=null;

  // int ContactId
  public ContactId: number=0;

  // int? ProfilId
  public ProfilId?: number=null;

  // int? AchRefId
  public AchRefId?: number=null;

  // string AzureGid
  public AzureGid?: string=null;

  // ICollection<IntUserStatutHistory> IntUserStatutHistories
  public IntUserStatutHistories: IntUserStatutHistory[]=[];

  // Profil Profil
  public Profil: Profil=null;

  // ICollection<Family> Families
  public Families: Family[]=[];

  // Contact Contact
  public Contact: Contact=null;

  // ICollection<IntUserPerimeters_XRP> IntUserPerimeters_XRP
  public IntUserPerimeters_XRP: IntUserPerimeters_XRP[]=[];
}